import { colors } from "../../../../../theme/tokens/variables";

import { TaskStatus } from "../../../../../types/TaskStatus";
import CheckIcon from "./icons/CheckIcon";
import CircularLoadingIcon from "./icons/CircularLoadingIcon";
import FailedIcon from "./icons/FailedIcon";
import WarningIcon from "./icons/WarningIcon";

const getBackgroundByStatus = (status: TaskStatus) => {
  switch (status) {
    case TaskStatus.COMPLETED:
      return colors.primaryGreen;
    case TaskStatus.COMPLETED_WITH_ERRORS:
      return "#EEAA00";
    case TaskStatus.CANCELED:
      return "#fba404";
    case TaskStatus.FAILED:
    case TaskStatus.FAILED_WITH_TERMINAL_ERROR:
    case TaskStatus.TIMED_OUT:
      return "#DD2222";
    case TaskStatus.IN_PROGRESS:
    case TaskStatus.SCHEDULED:
      return "white";
    case TaskStatus.SKIPPED:
      return "#F5BF42";
    default:
      return "";
  }
};

const CardStatusBadge = ({ status }: { status: TaskStatus }) => {
  return [
    TaskStatus.IN_PROGRESS,
    TaskStatus.SCHEDULED,
    TaskStatus.COMPLETED,
    TaskStatus.COMPLETED_WITH_ERRORS,
    TaskStatus.FAILED,
    TaskStatus.FAILED_WITH_TERMINAL_ERROR,
    TaskStatus.CANCELED,
    TaskStatus.SKIPPED,
    TaskStatus.TIMED_OUT,
  ].includes(status) ? (
    <div
      style={{
        position: "absolute",
        top: "-15px",
        right: "-15px",
        borderRadius: "30px",
        width: "30px",
        height: "30px",
        background: getBackgroundByStatus(status),
        color: "#aaaaaa",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        boxShadow: "0 0 4px black",
      }}
    >
      {[TaskStatus.IN_PROGRESS, TaskStatus.SCHEDULED].includes(status) ? (
        // disableShrink for lower CPU load
        // see: https://mui.com/components/progress/

        <CircularLoadingIcon />
      ) : null}
      {status === TaskStatus.COMPLETED ? <CheckIcon color="white" /> : null}
      {status === TaskStatus.COMPLETED_WITH_ERRORS ||
      status === TaskStatus.SKIPPED ? (
        <WarningIcon color="white" />
      ) : null}
      {[
        TaskStatus.CANCELED,
        TaskStatus.FAILED,
        TaskStatus.FAILED_WITH_TERMINAL_ERROR,
        TaskStatus.TIMED_OUT,
      ].includes(status) ? (
        <FailedIcon color="white" />
      ) : null}
    </div>
  ) : null;
};

export default CardStatusBadge;
